import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import i18n from "i18n";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { ButtonToolbar, Button } from "components/bootstrap";
import { DataTable } from "components/common";
import withTelemetry from "logic/telemetry/withTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import styles from "./FieldsList.css";
import { fieldValueProviderTitle } from "../pluginTitles";
const t = (key) => i18n.t(key, { ns: "event_definitions" });
const HEADER_KEYS = [
  "fields_list.field_name",
  "fields_list.is_key",
  "fields_list.value_source",
  "fields_list.data_type",
  "fields_list.configuration",
  "summary.actions"
];
const getFieldValueProviderPlugin = (type) => {
  if (type === void 0) {
    return void 0;
  }
  return PluginStore.exports("fieldValueProviders").find((p) => p.type === type);
};
const providerFormatter = (config) => {
  const configKeys = Object.keys(config).filter((key) => key !== "type");
  return /* @__PURE__ */ React.createElement("p", null, configKeys.map((key) => /* @__PURE__ */ React.createElement("span", { key, className: styles.providerOptions }, key, ": ", /* @__PURE__ */ React.createElement("em", null, JSON.stringify(config[key])))));
};
class FieldsList extends React.Component {
  constructor() {
    super(...arguments);
    this.handleAddFieldClick = () => {
      this.props.sendTelemetry(TELEMETRY_EVENT_TYPE.EVENTDEFINITION_FIELDS.ADD_CUSTOM_FIELD_CLICKED, {
        app_action_value: "add-custom-field-button"
      });
      const { onAddFieldClick } = this.props;
      onAddFieldClick();
    };
    this.handleEditClick = (fieldName) => () => {
      const { onEditFieldClick } = this.props;
      onEditFieldClick(fieldName);
    };
    this.handleRemoveClick = (fieldName) => () => {
      const { onRemoveFieldClick } = this.props;
      onRemoveFieldClick(fieldName);
    };
    this.fieldFormatter = (fieldName) => {
      const { fields, keys } = this.props;
      const config = fields[fieldName];
      const keyIndex = keys.indexOf(fieldName);
      const fieldProviderPlugin = getFieldValueProviderPlugin(config.providers[0].type);
      return /* @__PURE__ */ React.createElement("tr", { key: fieldName }, /* @__PURE__ */ React.createElement("td", null, fieldName), /* @__PURE__ */ React.createElement("td", null, keyIndex < 0 ? t("fields_list.no") : t("fields_list.yes")), /* @__PURE__ */ React.createElement("td", null, fieldValueProviderTitle(fieldProviderPlugin) || config.providers[0].type), /* @__PURE__ */ React.createElement("td", null, config.data_type), /* @__PURE__ */ React.createElement("td", null, providerFormatter(config.providers[0])), /* @__PURE__ */ React.createElement("td", { className: styles.actions }, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: this.handleRemoveClick(fieldName) }, t("fields_list.remove")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "xsmall", onClick: this.handleEditClick(fieldName) }, i18n.t("common:actions.edit")))));
    };
  }
  render() {
    const { fields } = this.props;
    const fieldNames = Object.keys(fields).sort(naturalSort);
    const addCustomFieldButton = /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: this.handleAddFieldClick }, t("field_form.add"));
    if (fieldNames.length === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("fields_list.no_fields")), addCustomFieldButton);
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      DataTable,
      {
        id: "event-definition-fields",
        headers: HEADER_KEYS.map((key) => t(key)),
        rows: fieldNames,
        dataRowFormatter: this.fieldFormatter,
        filterKeys: []
      }
    ), addCustomFieldButton);
  }
}
export default withTelemetry(FieldsList, "event-definition-fields");
